import React from "react";
import { useTranslation } from "react-i18next";
import { getCurrentShandeAge, getShanDeChildrenAmount, getShanDeTotalHelpedChildrenAmount } from "../../helpers/dataHelper";
import Reveal from "../animations/Reveal";
import CountUp from "../animations/CountUp";

function StatsSection() {
    const { t } = useTranslation();
    const duration = 2.4;
    const stats = [
        { value: getCurrentShandeAge(), label: t("statYearsLabel"), desc: t("statYearsDescription") },
        { value: getShanDeTotalHelpedChildrenAmount(), suffix: "+", label: t("statHelpedLabel"), desc: t("statHelpedDescription") },
        { value: getShanDeChildrenAmount(), label: t("statCurrentLabel"), desc: t("statCurrentDescription") },
    ];

    return (
        <section className="landing-stats">
            <div className="container">
                <Reveal className="landing-stats-grid" stagger={0.15}>
                    {stats.map((stat) => (
                        <div className="landing-stat" data-reveal key={stat.label}>
                            <div className="landing-stat-num">
                                <CountUp value={stat.value} suffix={stat.suffix} duration={duration} />
                            </div>
                            <div className="landing-stat-label">{stat.label}</div>
                            <p className="landing-stat-desc">{stat.desc}</p>
                        </div>
                    ))}
                </Reveal>
            </div>
        </section>
    );
}
export default StatsSection;
